var map = {
	"./categories.js": "a77e",
	"./composition.js": "f317",
	"./cuttingparams.js": "615e",
	"./dxf-imports.js": "3bef",
	"./fonts.js": "e407",
	"./icons.js": "a549",
	"./matters.js": "b305",
	"./products.js": "6c45",
	"./thicknesses.js": "c40b",
	"./translations.js": "de64",
	"./users.js": "d8e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d76a";